import { IndustryCard } from '../cards/IndustryCard';

const IndustryList = (props) => {
  const { industries } = props;
  return (
    <ul className="industry-category-list row">
      {industries.map((industry) => (
        <>
          <li className="industry-category-card col-md-6 col-lg-3">
            <IndustryCard {...industry} />
          </li>
        </>
      ))}
    </ul>
  );
};

export default IndustryList;
